---
title: "elsewhere on the internet"
subtitle: "linkposting"
date: 2025-01-30 22:09
---

I haven't written much on this blog this month, but in my defense I've been writing elsewhere on the internet:

- [Apply to SPARC 2025!](https://sparc24jcs.substack.com/p/apply-to-sparc-2025) on the SPARC '24 JC Blog, a Substack I cowrite with some friends,
- [in search of lost time](https://mitadmissions.org/blogs/entry/in-search-of-lost-time/) on the MIT Admissions blog, which I cowrote with Alan Z. '23,
- [my Twitter](https://twitter.com/cjquines) has recently been somewhat more active.

Some drafts I've been working on:

- Mystery Hunt, and the phenomenology of puzzlehunting
- ecosystems of iterated desires, egotism, ambition, revealed preferences, wireheading
- the line between semantics and syntax, over programming, linguistics, formal logic

Things I want to write about but haven't gotten around to at all:

- models of emotional intimacy, particularly, inclusion-of-other-in-self
- work, the all-expansive mandate I've been taking on, how that pressure feels
- what I feel about New York City so far, so I can stop answering that question

Okay, that's it, see you next year.
